<div
    #kebabMenu
    class="agpr-kebabMenu"
    [ngClass]="{
        'agpr-kebabMenu--active': panelVisible,
        'agpr-kebabMenu--visible': kebabMenuVisible,
        'agpr-kebabMenu--menuItem': isMenuItem && panelAlignCenter
    }"
    [id]="id + '.kebabMenu'"
>
    <div #button class="agpr-kebabMenu-btn">
        <agpr-button
            [id]="`${id}_openPanel`"
            class="agpr-kebabMenu-button"
            [style]="style"
            [label]="label"
            [icon]="icon"
            [tooltip]="tooltip"
            [tooltipPosition]="tooltipPosition"
            [ariaLabel]="ariaLabel"
            [disabled]="disabled"
            [loading]="loading"
            (click)="onMouseClick($event)"
            [ariaHasPopup]="'menu'"
            [expanded]="panelVisible ? true : false"
            (keydown)="onButtonKeydown($event)"
            [initiallyFocusable]="initiallyFocusable"
        >
            @if (isMenuItem) {
                <span class="agpr-kebabMenu-btn-arrowIcon fa-solid fa-angle-right" aria-hidden="true"></span>
            }
        </agpr-button>
    </div>
    <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
    <div
        #panel
        class="agpr-clickOutsideExcluded agpr-kebabMenu-panel"
        [ngClass]="panelClass"
        [@panelState]="panelVisible ? 'visible' : 'hidden'"
        [style.display]="panelVisible ? 'block' : 'none'"
        (keydown)="onPanelKeydown($event)"
        (mouseleave)="hide(true)"
        [style]="panelStyle"
    >
        @if (isMenuItem || useScrollPanel) {
            <agpr-scroll-panel [class.agpr-kebabMenu-panel-noScroll]="!needsScroll">
                <div #itemswrapper>
                    <ul
                        role="menu"
                        class="agpr-kebabMenu-panel-items"
                        [ngClass]="{
                            'agpr-kebabMenu-panel-items--right': panelPositionX === 'right' || textAlignment === 'right',
                            'agpr-kebabMenu-panel-items--textAlignment': textAlignment === 'left'
                        }"
                        [id]="id + '_list'"
                    >
                        @for (option of optionsToDisplay; track i; let i = $index, first = $first, last = $last) {
                            @if (option.items?.length > 0) {
                                <li
                                    role="menuitem"
                                    [ngClass]="{
                                        'agpr-kebabMenu-panel-item--last': last,
                                        'agpr-kebabMenu-panel-item--first': first
                                    }"
                                >
                                    <agpr-kebab-menu
                                        class="agpr-kebabMenu-panel-item agpr-kebabMenu-panel-kebabMenu"
                                        [id]="id + '_listItem_' + i"
                                        [isMenuItem]="true"
                                        [scrollableParentElements]="scrollableParents"
                                        [label]="option.label"
                                        [style]="''"
                                        icon=""
                                        [showIcon]="showIcon"
                                        [disabled]="option.disabled"
                                        [options]="option.items"
                                        [alignmentPriority]="option.style.alignmentPriority"
                                        [panelPositionX]="option.style.panelPositionX"
                                        [hidePanelOnMouseLeave]="false"
                                        (panelShown)="closeOtherSubMenus(i)"
                                        (panelHidden)="hide()"
                                        (itemSelected)="hide(false, true)"
                                        [panelAlignCenter]="panelAlignCenter"
                                        [addAtPosition]="addAtPosition"
                                        [textAlignment]="textAlignment"
                                    ></agpr-kebab-menu>
                                </li>
                            } @else {
                                @if (option.separator) {
                                    <li
                                        role="separator"
                                        class="agpr-kebabMenu-panel-separator"
                                    ></li>
                                } @else {
                                    <li
                                        role="menuitem"
                                        class="agpr-kebabMenu-panel-item"
                                        [ngClass]="{
                                            'agpr-kebabMenu-panel-item--last': last,
                                            'agpr-kebabMenu-panel-item--first': first,
                                            'agpr-kebabMenu-panel-item--disabled': option.disabled
                                        }"
                                        [id]="id + '_listItem_' + i"
                                        tabindex="0"
                                        (click)="onItemClick($event, option)"
                                        (keyup.enter)="onItemClick($event, option, false)"
                                    >
                                        @if (option.icon && showIcon) {
                                            <span class="agpr-kebabMenu-panel-item-icon {{ option.icon }}" aria-hidden="true"></span>
                                        }
                                        @if (!itemTemplate) {
                                            <span
                                                class="agpr-kebabMenu-panel-item-label"
                                                [style.margin-left]="option.style?.labelMarginLeft || '0'"
                                            >
                                                {{ option.label | localize }}
                                            </span>
                                        }
                                        @if (option.isLocked) {
                                            <span
                                                class="agpr-kebabMenu-panel-item-lockIcon fa fa-lock fa-duotone"
                                                aria-hidden="true"
                                            ></span>
                                        }
                                        <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
                                    </li>
                                }
                            }
                        }
                    </ul>
                </div>
            </agpr-scroll-panel>
        }@else {
            <div #itemswrapper>
                <ul
                    role="menu"
                    class="agpr-kebabMenu-panel-items"
                    [ngClass]="{
                        'agpr-kebabMenu-panel-items--right': panelPositionX === 'right' || textAlignment === 'right',
                        'agpr-kebabMenu-panel-items--textAlignment': textAlignment === 'left'
                    }"
                    [id]="id + '_list'"
                >
                    @for (option of optionsToDisplay; track i; let i = $index, first = $first, last = $last) {
                        @if (option.items?.length > 0) {
                            <li
                                role="menuitem"
                                [ngClass]="{
                                    'agpr-kebabMenu-panel-item--last': last,
                                    'agpr-kebabMenu-panel-item--first': first
                                }"
                            >
                                <agpr-kebab-menu
                                    class="agpr-kebabMenu-panel-item agpr-kebabMenu-panel-kebabMenu"
                                    [id]="id + '_listItem_' + i"
                                    [isMenuItem]="true"
                                    [scrollableParentElements]="scrollableParents"
                                    [label]="option.label"
                                    [style]="''"
                                    icon=""
                                    [showIcon]="showIcon"
                                    [disabled]="option.disabled"
                                    [options]="option.items"
                                    [alignmentPriority]="option.style.alignmentPriority"
                                    [panelPositionX]="option.style.panelPositionX"
                                    [hidePanelOnMouseLeave]="false"
                                    (panelShown)="closeOtherSubMenus(i)"
                                    (panelHidden)="hide()"
                                    (itemSelected)="hide(false, true)"
                                    [panelAlignCenter]="panelAlignCenter"
                                    [addAtPosition]="addAtPosition"
                                    [textAlignment]="textAlignment"
                                ></agpr-kebab-menu>
                            </li>
                        } @else {
                            @if (option.separator) {
                                <li
                                    role="separator"
                                    class="agpr-kebabMenu-panel-separator"
                                ></li>
                            } @else {
                                <li
                                    role="menuitem"
                                    class="agpr-kebabMenu-panel-item"
                                    [ngClass]="{
                                        'agpr-kebabMenu-panel-item--last': last,
                                        'agpr-kebabMenu-panel-item--first': first,
                                        'agpr-kebabMenu-panel-item--disabled': option.disabled
                                    }"
                                    [id]="id + '_listItem_' + i"
                                    tabindex="0"
                                    (click)="onItemClick($event, option)"
                                    (keyup.enter)="onItemClick($event, option, false)"
                                >
                                    @if (option.icon && showIcon) {
                                        <span class="agpr-kebabMenu-panel-item-icon {{ option.icon }}" aria-hidden="true"></span>
                                    }
                                    @if (!itemTemplate) {
                                        <span
                                            class="agpr-kebabMenu-panel-item-label"
                                            [style.margin-left]="option.style?.labelMarginLeft || '0'"
                                        >
                                            {{ option.label | localize }}
                                        </span>
                                    }
                                    @if (option.isLocked) {
                                        <span
                                            class="agpr-kebabMenu-panel-item-lockIcon fa fa-lock fa-duotone"
                                            aria-hidden="true"
                                        ></span>
                                    }
                                    <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option}"></ng-container>
                                </li>
                            }
                        }
                    }
                </ul>
            </div>
        }
    </div>
</div>
